import React from "react";

import StatusPill from "./StatusPill";
import { formatMoney } from "../financeMoney";

const WithdrawalTable = ({ items, onSelect }) => (
  <div className="fin-table-wrap">
    <table className="fin-table">
      <thead>
        <tr>
          <th>Reference</th>
          <th>Date</th>
          <th>Status</th>
          <th className="fin-table-amount-col">Amount</th>
        </tr>
      </thead>

      <tbody>
        {items.map((payout) => (
          <tr
            key={payout.id}
            className="fin-table-row"
            tabIndex={0}
            role="button"
            onClick={() => onSelect(payout)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") onSelect(payout);
            }}
          >
            <td>
              <span className="fin-table-title">#{payout.reference}</span>
            </td>

            <td className="fin-table-muted">
              {[payout.dateLabel, payout.timeLabel].filter(Boolean).join(" · ")}
            </td>

            <td>
              <StatusPill status={payout.status} label={payout.statusLabel} />
            </td>

            <td className="fin-table-amount-col fin-table-amount">
              {formatMoney(payout.amount)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default WithdrawalTable;
